<div class="expandable-cell">
  <div [class.expanded]="isExpanded" [class.truncated]="!isExpanded">
    {{ cellValue }}
  </div>
  @if (needsExpansion) {
    <button 
      class="e-expand-btn" 
      (click)="toggleExpand($event)"
      type="button"
    >
      <span [ngClass]="isExpanded ? 'fas fa-circle-chevron-up' : 'fas fa-circle-chevron-down'"></span>
    </button>
  }
</div>